import React from "react";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import YouTubeIcon from "@mui/icons-material/YouTube";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        sx={{ textAlign: "center", bgcolor: "#1A1A19", color: "white", p: 3 }}
      >
        <Box
          sx={{
            my: 3,
            "& svg": {
              fontSize: "60px",
              cursor: "pointer",
              mr: 2,
            },
            "& svg:hover": {
              color: "goldenrod",
              transform: "translateX(5px)",
              transition: "all 400ms",
            },
          }}
        >
          {/* Social media icons */}
          {/* <InstagramIcon />
          <TwitterIcon />
          <GitHubIcon />
          <YouTubeIcon /> */}
        </Box>
        {/* Developer details */}
        <Typography
          variant="h5"
          sx={{
            "@media (max-width:600px)": {
              fontSize: "1rem",
            },
          }}
        >
          All Rights Reserved &copy; ERESTA EVIDENTE
        </Typography>
        <Typography
          variant="body2"
          sx={{
            "@media (max-width:600px)": {
              fontSize: "0.8rem",
            },
          }}
        >
          Developed by: Muhammad Zaaqib
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
